// arms埋点. js报错-监控-报警
// 统一在 小猴英语-www_vue_html5 监控下查看, 根据url区分报错页面
/* eslint-disable */
if (process.env.NODE_ENV === 'production') { // production development
    const BrowerLogger = require('alife-logger');
    const __bl = BrowerLogger.singleton({ pid: 'g60fu7e3c0@941803f0b5fdff0', appType: 'web', imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?', sendResource: true, enableLinkTrace: true, behavior: true });
}